import { Info } from '@material-ui/icons';
import WeekEventChart from './weekEventChart';

const WeekEvent = ({ conn, dongCode }) => {
  return (
    <>
      <table className="MapRightSubTitle">
        <tr>
          <th>
            <span>주간 이벤트 발생</span>
            <div className="tooltipBoxBB">
              <div className="tooltipBB-container">
                <i>
                  <Info style={{ color: 'grey', marginLeft: '5px', marginBottom: '2px' }}></Info>
                </i>
                <span className="tooltipBB">
                  <img className="dotimg" src="/images/icon_yl2.png" alt="경고" />
                  &nbsp;&nbsp;&nbsp;경고 : 1일 중 1회 경고 표출 시 해당 날 경고로 지정
                  <br />
                  <img className="dotimg" src="/images/icon_rd2.png" alt="위험" />
                  &nbsp;&nbsp;&nbsp;위험 : 1일 1회 위험 표출 시 해당날 날 위험으로 지정
                  <br />
                  <img className="dotimg" src="/images/icon_gray2.png" alt="미작동" />
                  &nbsp;&nbsp;&nbsp;미작동 : 1일 24시간 동안 미작동 표출 시 미작동으로 지정
                  <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <small>
                    ※ 모두 표출 시 우선 순위 : 위험 {'>'} 미작동 {'>'} 경고
                  </small>
                </span>
              </div>
            </div>
          </th>
          <td>
            <img className="dotimg" src="/images/icon_yl2.png" alt="경고" />
            경고
            <img className="dotimg" src="/images/icon_rd2.png" alt="위험" />
            위험
            <img className="dotimg" src="/images/icon_gray2.png" alt="미작동" />
            미작동
          </td>
        </tr>
      </table>
      <div className="graphBgB">
        <WeekEventChart conn={conn} dongCode={dongCode}></WeekEventChart>
      </div>
    </>
  );
};

export default WeekEvent;
